import type { AnalysisRow } from "../shared/analysisListTypes";
import {
  normalizeSituacaoNomeApiMeritocracia,
  normalizeV2ListItemDates,
  resolveV2SituacaoParaLista,
} from "../shared/analysisListUtils";

export const mapSolicitacoesV2ToAnalysisRows = (
  items: unknown[],
  ano: number,
): AnalysisRow[] => {
  if (!Array.isArray(items)) return [];

  return items.map((item: any, index) => {
    const datas = normalizeV2ListItemDates(item);
    const situacaoFinal = resolveV2SituacaoParaLista(
      item,
      normalizeSituacaoNomeApiMeritocracia,
    );
    const solicitacaoId = item?.solicitacaoId ?? null;

    return {
      id: solicitacaoId ?? index + 1,
      solicitacao: item?.solicitacao || "—",
      situacao: situacaoFinal,
      envioDocumentacao: datas.enviadoPeloSindicatoEm,
      ultimaAtualizacao: datas.atualizadoPeloSindicatoEm,
      solicitacaoAdequacao: datas.adequacaoSolicitadaEm,
      adequacaoDocumentacao: datas.adequacaoRealizadaEm,
      conclusaoAnalise: datas.analiseConcluidaEm,
      ano,
      idQuestionarioResposta: solicitacaoId,
      idSindicato: item?.idSindicato ?? item?.sindicatoId ?? null,
      historicoHabilitado: !!solicitacaoId && solicitacaoId !== 0,
      cnpj: item?.cnpj ?? null,
      sigla: item?.sigla ?? null,
      rowKey: `${item?.idSindicato ?? "x"}-${solicitacaoId ?? index}-${ano}`,
    };
  });
};
